<template>
  <div>
    <v-content class="pt-0">
      <v-radio-group v-model="filterBy" row class="radio-group">
        <v-layout row wrap>
          <v-flex md3 xs6>
            <v-radio class="radio-btn" label="NFL Games" :value="0"></v-radio>
          </v-flex>
          <v-flex md3 xs6>          
            <v-radio class="radio-btn" label="NCAA Games" :value="1"></v-radio>
          </v-flex>
          <v-flex md3 xs6>
            <v-radio class="radio-btn" label="Other Event" :value="2"></v-radio>
          </v-flex>
          <v-flex md3 xs6>
            <v-radio class="radio-btn" label="All Events" :value="null"></v-radio>
          </v-flex>
        </v-layout>
      </v-radio-group>
      <v-alert color="error" class="err" icon="warning" value="true" v-if="err">{{err}}</v-alert>
      <div class="table__overflow">
        <table class="datatable table">
          <thead>
            <tr>
              <th role="columnheader" scope="col" class="column text-xs-left">Event</th>
              <th role="columnheader" scope="col" class="column text-xs-center">Type</th>
              <th role="columnheader" scope="col" class="column text-xs-center">Date</th>
              <th role="columnheader" scope="col" class="column text-xs-right"></th>
            </tr>
            <tr class="datatable__progress"><th colspan="100%" class="column"></th></tr>
          </thead>
          <tbody>
            <tr v-for="(event, index) in events" :key="index" v-if="filterBy === null || event.type === filterBy">
              <td class="text-xs-left">{{event.name}}</td>
              <td class="text-xs-center">{{getType(event.type)}}</td>
              <td class="text-xs-center">{{event.start}}</td>
              <td class="text-xs-right padding-off td-flex">
                <v-btn fab dark small color="primary" @click.stop="editEventTrigger(event, index)">
                  <v-icon dark>edit</v-icon>
                </v-btn>
                <v-btn fab dark small color="accent" @click.stop="deleteEvent(event, index)">
                  <v-icon dark>close</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </v-content>
    <v-dialog v-model="dialogEdit" persistent max-width="500px">
      <edit-modal modalType="Event" v-if="dialogEdit" :event="editEvent" :index="editIndex" @close="closeEdit"></edit-modal>
    </v-dialog>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <delete-modal modalType="Event" path="event" :id="deleteId" v-if="dialogDelete" @close="dialogDelete = false" @submit="submitDelete"></delete-modal>
    </v-dialog>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import webHelper from '../../helpers/web';
  import EditEvent from '../modals/Event';
  import Delete from '../modals/Delete';

  export default {
    data: () => ({
      filterBy: null,
      editEvent: null,
      editIndex: null,
      dialogEdit: false,
      dialogDelete: false,
      deleteId: null,
      deleteIndex: null,
      err: '',
    }),
    components: {
      deleteModal: Delete,
      editModal: EditEvent,
    },
    computed: mapGetters({
      events: 'events',
    }),
    methods: {
      editEventTrigger(event, index) {
        this.editEvent = event;
        this.editIndex = index;
        this.dialogEdit = true;
      },
      closeEdit() {
        this.editEvent = null;
        this.editIndex = null;
        this.dialogEdit = false;
      },
      deleteEvent(event, index) {
        this.deleteId = event._id;
        this.deleteIndex = index;
        this.dialogDelete = true;
      },
      getType(type) {
        switch (parseInt(type, 10)) {
          case 0:
            return 'NFL';
          case 1:
            return 'NCAA';
          case 2:
          default:
            return 'Other';
        }
      },
      openDelete(id, index) {
        this.deleteId = id;
        this.deleteIndex = index;
        this.dialogDelete = true;
      },
      submitDelete() {
        this.$store.dispatch('removeEvent', this.deleteId);
        this.deleteId = null;
        this.deleteIndex = null;
        this.dialogDelete = false;
      },
    },
    async created() {
      const res = await webHelper.get(this, 'event');
      if (res.failed) {
        this.err = 'Failed to get the Events.';
        return;
      }
      this.$store.dispatch('setEvents', res.events);
    },
  };
</script>


<style scoped lang="scss">
  .radio-group {
    padding: 18px 0 !important;
  }
  .radio-btn {
    max-width: 150px;
    margin-left: 10px;
  }
  table {
    border-top: 1px solid rgba(0,0,0, 0.12);
  }
  .padding-off {
    padding: 0 !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/eventManager/Events.vue